module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_1_05-04b15b883c24856cdb43308497a11f26.jpg";